if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');

			this.pickupAvailabilityExtended = this.querySelector('pickup-availability-extended');

			// Gallery thumbnails

			if ( this.productSlider ) {

				const productGaleryThumbnails = this.querySelector('.product-gallery__thumbnails-holder');

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i == 0 )  {
							elm.classList.add('active');
						}
						elm.addEventListener('click',e=>{
							if ( this.productSlider.sliderEnabled ) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).getBoundingClientRect().top,
									behavior: 'smooth'
								});
								this.thumbnailNavigationHelper(e.currentTarget.dataset.index);
							}
							productGaleryThumbnails.scrollTo({
								left: elm.offsetLeft - 50,
								behaviour: 'smooth'
							})
						});
					})

					this.productSlider.addEventListener('change', e=>{
						this.thumbnailNavigationHelper(e.target.index);
					});

				}

				this.productSlider.addEventListener('change', e=>{
					if ( this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				// Parallax

				this.productSlider.addEventListener('ready', (e)=>{
					if ( this.firstProductGalleryIndex ) {
						this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
					}
				});

			}

			// Product variant event listener for theme specific logic

			this.productVariants = this.querySelector('product-variants[data-main-product-variants]');
			if ( this.productVariants ) {

				this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this.onVariantChangeHandler({target:this.productVariants});

				// refresh color
				this.querySelectorAll('.product-variant__item--radio input').forEach(input=>{
					input.addEventListener('click', () => {
						const inputParent = input.closest('.product-variant__item--radio');
						const textLabel = inputParent.closest('.product-variant').querySelector('.product-variant__item-text-label');
						if ( textLabel ) {
							textLabel.textContent = input.value;
						}
					})
				});

			}

			// show cart drawer when element is added to cart

			if ( ! document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay' ) {
				
				let addToCartEnter = false;
				if ( this.querySelector('[data-js-product-add-to-cart]') ) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							addToCartEnter = true;
						}
					})
				}	

				if ( this.querySelector('[data-js-product-form]') ) {
					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
						document.getElementById('site-cart-sidebar').show();
							if ( document.getElementById('cart-recommendations-sidebar') ) {
							document.getElementById('cart-recommendations-sidebar').generateRecommendations();
						}
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('#site-cart-sidebar [data-js-close]').focus();
							}, 200);
						}
					});
				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			// hide buy now button if stock disabled

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart][data-main-product-add-to-cart]');
			if ( addToCartButton ) {
				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				const buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
			}

		}

		thumbnailNavigationHelper(index=0){
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
				if ( i == index )
					elm.classList.add('active');
				else 
					elm.classList.remove('active');
			});
		}

		onVariantChangeHandler(e){

			let variant = e.target.currentVariant;
			if ( variant ) {

				// Variant media filtering
				if ( this.hasAttribute('data-filter-variant-media') && variant.featured_media != null ) {
					this._filterVariantMedia(variant.featured_media.id);
				}

				// image handling

				if ( variant.featured_media != null ) {
					let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
					if ( variantImg ) {
						if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
							if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
								this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
							} else {
								this.firstProductGalleryIndex = variantImg.dataset.index;
							}
						} else {
							if ( variantImg.getBoundingClientRect().top > window.innerHeight ) {
								variantImg.scrollIntoView({behavior: 'smooth', block: 'center'});
							} else if ( variantImg.getBoundingClientRect().top < 0 ) {
								variantImg.scrollIntoView({behavior: 'smooth', block: 'center'});
							}
						}
					}
				}

				this.querySelectorAll('.product-variant__item--color [data-selected]').forEach(elm=>{
					elm.closest('.product-variant').querySelector('.product-variant__item-text-label').textContent = elm.value;
				});

			}

		}

		_filterVariantMedia(activeMediaId) {
			// Remove the server-rendered <style> block on first interaction
			const filterStyle = document.getElementById('variant-media-filter-' + this.id);
			if ( filterStyle ) filterStyle.remove();

			// Build set of all variant media IDs (cached on first call)
			if ( !this._variantMediaIds ) {
				const ids = this.getAttribute('data-filter-variant-media') || '';
				this._variantMediaIds = new Set(ids.split(',').filter(Boolean));
				// Get hero media ID (first media, never hidden)
				const firstItem = this.productGallery.querySelector('.product-gallery-item');
				if ( firstItem ) this._heroMediaId = firstItem.dataset.mediaId;
			}

			const activeId = String(activeMediaId);

			// Toggle gallery items
			this._variantMediaIds.forEach(id => {
				const item = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + id + '"]');
				if ( item ) {
					if ( id === activeId || id === this._heroMediaId ) {
						item.style.removeProperty('display');
					} else {
						item.style.display = 'none';
					}
				}
				// Toggle matching thumbnails
				const thumb = this.querySelector('.product-gallery__thumbnails .thumbnail[data-media-id="' + id + '"]');
				if ( thumb ) {
					if ( id === activeId || id === this._heroMediaId ) {
						thumb.style.removeProperty('display');
					} else {
						thumb.style.display = 'none';
					}
				}
			});

			// Reinitialise slider if present
			if ( this.productSlider && this.productSlider.resetSlider ) {
				this.productSlider.resetSlider();
			}
		}
		
	}

  if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}
// Aunty Cherish — expand swatches on click
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.product-variant__container--radio--wrap').forEach(function(el) {
    el.classList.add('collapsed');
    el.addEventListener('click', function(e) {
      if (e.target.closest('label') || e.target.closest('input')) return;
      el.classList.remove('collapsed');
      el.classList.add('expanded');
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('[data-hh-bundle-selector]').forEach(function(selector) {
    var productForm = selector.closest('product-form');
    if (!productForm) return;

    var quantityInput = productForm.querySelector('input[name="quantity"]');
    if (!quantityInput) return;
    var addButton = productForm.querySelector('[data-main-product-add-to-cart]');
    var addButtonText = addButton ? addButton.querySelector('[data-js-product-add-to-cart-text]') : null;
    var customLine = selector.querySelector('[data-hh-bundle-custom]');
    var fullPrice = parseFloat(selector.getAttribute('data-hh-full-price') || '65');
    var dealPrice = parseFloat(selector.getAttribute('data-hh-deal-price') || '50');
    var dealMin = parseInt(selector.getAttribute('data-hh-deal-min') || '3', 10);

    function money(amount) {
      if (Math.round(amount) === amount) return '$' + Math.round(amount);
      return '$' + amount.toFixed(2);
    }

    function totalForQty(qty) {
      var unit = qty >= dealMin ? dealPrice : fullPrice;
      return qty * unit;
    }

    function updateDisplay() {
      var qty = parseInt(quantityInput.value || '1', 10);
      if (!qty || qty < 1) qty = 1;

      selector.querySelectorAll('[data-hh-bundle-qty]').forEach(function(option) {
        var active = parseInt(option.getAttribute('data-hh-bundle-qty'), 10) === qty;
        option.classList.toggle('is-active', active);
        option.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (customLine) {
        if (qty > 4) {
          customLine.textContent = qty + ' bundles · ' + (qty * 50) + 'g · ' + money(totalForQty(qty));
          customLine.hidden = false;
        } else {
          customLine.hidden = true;
          customLine.textContent = '';
        }
      }

      if (addButtonText && addButton && !addButton.disabled) {
        addButtonText.textContent = 'Add ' + qty + ' bundle' + (qty === 1 ? '' : 's') + ' · ' + money(totalForQty(qty));
      }
    }

    function setQuantity(button) {
      var qty = button.getAttribute('data-hh-bundle-qty');
      if (!qty) return;

      quantityInput.value = qty;
      quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      updateDisplay();
    }

    var activeButton = selector.querySelector('[data-hh-bundle-qty].is-active') || selector.querySelector('[data-hh-bundle-qty="3"]');
    if (activeButton) setQuantity(activeButton);

    selector.querySelectorAll('[data-hh-bundle-qty]').forEach(function(button) {
      button.addEventListener('click', function() {
        setQuantity(button);
      });
    });

    quantityInput.addEventListener('input', updateDisplay);
    quantityInput.addEventListener('change', updateDisplay);
    productForm.querySelectorAll('.qty-button').forEach(function(button) {
      button.addEventListener('click', function() {
        window.setTimeout(updateDisplay, 0);
      });
    });

    updateDisplay();
  });
});
